import React from 'react';
import { Link } from 'react-router-dom';
import { FaLinkedin, FaFacebookF, FaTwitter, FaInstagram } from 'react-icons/fa';
import darimLogo from '../assets/images/darimlogo.jpeg';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-gray-900 text-white pt-20 pb-8 mt-20">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 pb-12 border-b border-gray-800">
                    {/* About Column */}
                    <div className="lg:col-span-1.5">
                        <div className="flex items-center gap-3 mb-6">
                            <img 
                                src={darimLogo} 
                                alt="DARIM NGO Logo" 
                                className="h-10 w-auto"
                            />
                            <span className="text-2xl font-bold font-heading">Darim NGO</span>
                        </div>
                        <p className="text-gray-400 mb-6 leading-relaxed">
                            Empowering communities and transforming lives through education,
                            healthcare, and sustainable development initiatives.
                        </p>
                        <div className="flex gap-4">
                            <a
                                href="https://www.linkedin.com/company/darim-india/?originalSubdomain=in"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-primary hover:-translate-y-1 transition-all duration-300 text-xl"
                                aria-label="LinkedIn"
                            >
                                <FaLinkedin />
                            </a>
                            <a
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-primary hover:-translate-y-1 transition-all duration-300 text-xl"
                                aria-label="Facebook"
                            >
                                <FaFacebookF />
                            </a>
                            <a
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-primary hover:-translate-y-1 transition-all duration-300 text-xl"
                                aria-label="Twitter"
                            >
                                <FaTwitter />
                            </a>
                            <a
                                href="#"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 flex items-center justify-center bg-gray-800 rounded-lg hover:bg-primary hover:-translate-y-1 transition-all duration-300 text-xl"
                                aria-label="Instagram"
                            >
                                <FaInstagram />
                            </a>
                        </div>

                    </div>

                    {/* Quick Links */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 text-white">Quick Links</h4>
                        <ul className="space-y-3">
                            {[
                                { name: 'About Us', path: '/about' },
                                { name: 'Our Programs', path: '/programs' },
                                { name: 'Impact Stories', path: '/impact' },
                                { name: 'Contact Us', path: '/contact' },
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-300 inline-block">
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Get Involved */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 text-white">Get Involved</h4>
                        <ul className="space-y-3">
                            {[
                                { name: 'Donate Now', path: '/donate' },
                                { name: 'Volunteer', path: '/volunteer' },
                                { name: 'Partner With Us', path: '/partner' },
                                { name: 'Careers', path: '/careers' },
                            ].map((link, index) => (
                                <li key={index}>
                                    <Link to={link.path} className="text-gray-400 hover:text-white hover:translate-x-1 transition-all duration-300 inline-block">
                                        {link.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h4 className="text-lg font-bold mb-6 text-white">Contact Us</h4>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3 text-gray-400">
                                <span className="text-xl mt-1">📍</span>
                                <span>Main Market Ghansali, Tehri Garhwal, Uttarakhand - 249155</span>
                            </li>
                            <li className="flex items-center gap-3 text-gray-400">
                                <span className="text-xl">🌐</span>
                                <a href="https://darimindia.org/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">darimindia.org</a>
                            </li>
                            <li className="flex items-center gap-3 text-gray-400">
                                <span className="text-xl">📞</span>
                                <a href="tel:+918979151025" className="hover:text-white transition-colors">+91 8979151025</a>
                            </li>
                            <li className="flex items-center gap-3 text-gray-400">
                                <span className="text-xl">📧</span>
                                <a href="mailto:info@darimindia.org" className="hover:text-white transition-colors">info@darimindia.org</a>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Apeato Connection */}
                <div className="bg-accent/10 border border-accent/30 rounded-xl p-6 mb-12 text-center">
                    <p className="text-white/90 m-0">
                        🌟 <strong className="text-accent-light">Apeato</strong> - Our social enterprise supporting NGO initiatives.
                        <a href="https://apeato.com" target="_blank" rel="noopener noreferrer" className="text-accent-light font-bold ml-2 hover:text-white hover:translate-x-1 transition-all duration-300 inline-block">
                            Visit Apeato →
                        </a>
                    </p>
                </div>

                {/* Bottom Bar */}
                <div className="flex flex-col md:flex-row justify-between items-center pt-8 text-sm text-gray-500 border-t border-gray-800">
                    <p>&copy; {currentYear} Darim NGO. All rights reserved.</p>
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
                        <span className="text-gray-700">•</span>
                        <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
                        <span className="text-gray-700">•</span>
                        <Link to="/transparency" className="hover:text-white transition-colors">Transparency</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
